import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { useNotificationsHttpClient } from './useNotificationsHttpClient';

export interface UseUpdateNotificationsArgs {
	notificationId: string;
	type: NotificationUpdateType;
}

type MutationOptions<T = unknown, U = unknown> = Omit<UseMutationOptions<U, unknown, T>, 'mutationFn'>;
export const useUpdateNotifications = (id: string, options?: MutationOptions<UseUpdateNotificationsArgs>) => {
	const http = useNotificationsHttpClient();
	return useMutation([id], ({ notificationId, type }: UseUpdateNotificationsArgs) => http.post(`app_notifications/${notificationId}/${type}`), options);
};

export enum NotificationUpdateType {
	MarkAsRead = 'mark_as_read',
	MarkAsSeen = 'mark_as_seen',
}
